/**
 * Created by PanJiaChen on 16/11/18.
 */
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()
  const diff = (now - d) / 1000
  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

// export function toggleClass() {
//   let classString = document.body.className
//   let className = 'custom-theme'
//   const nameIndex = classString.indexOf(className)
//   if (nameIndex === -1) {
//     classString += '' + className
//   } else {
//     classString =
//       classString.substr(0, nameIndex) +
//       classString.substr(nameIndex + className.length)
//   }
//   document.body.className = classString
// }
export function appointDate(leftDay = 0, appointDate = '') {
  let timestamp
  if (appointDate) {
    timestamp = new Date(appointDate).getTime() + leftDay * 86400000
  } else {
    timestamp = new Date().getTime() + leftDay * 86400000
  }
  const curDate = new Date(timestamp)
  const year = curDate.getFullYear()
  const month = curDate.getMonth() + 1 < 10 ? '0' + (curDate.getMonth() + 1) : curDate.getMonth() + 1
  const date = curDate.getDate() < 10 ? '0' + curDate.getDate() : curDate.getDate()
  return year + '-' + month + '-' + date
}

// 设置页面滚动条高度
export const setScroll = vm => {
  const scrollTop = vm.$route.meta.scrollTop
  const $content = document.querySelector(vm.$route.meta.scrollContainer)
  if (scrollTop && $content) {
    $content.scrollTop = scrollTop
  }
}

export function download(href, title) {
  const a = document.createElement('a')
  a.setAttribute('href', href)
  a.setAttribute('target', '_blank')
  a.setAttribute('download', title)
  a.click()
}

export function strToAsterisk(str = '') {
  if (!str) {
    return ''
  }
  const strLen = str.length
  if (strLen === 0) {
    return ''
  }
  let strPrefix
  let strSuffix = ''
  if (strLen === 1) {
    strPrefix = str[0]
    strSuffix = str[0]
  }
  if (strLen === 2) {
    strPrefix = str.slice(0, 2)
    strSuffix = str.slice(strLen - 2, strLen)
  }
  if (strLen >= 3) {
    strPrefix = str.slice(0, 3)
    strSuffix = str.slice(strLen - 3, strLen)
  }
  return strPrefix + '***' + strSuffix
}

export function strEmailToAsterisk(str = '') {
  if (!str) {
    return ''
  }
  const strArr = str.split('@')
  if (strArr.length < 2) {
    return ''
  }
  const strStart = strArr[0]
  const strStartlength = strStart.length
  let strPrefix = ''
  if (strStartlength === 1) {
    strPrefix = str[0]
  }
  if (strStartlength >= 2) {
    strPrefix = str.slice(0, 2)
  }
  return strPrefix + '***@' + strArr[1]
}
